/*@flow*/
import type { Node } from 'react';
import React from 'react';
import DateRange from './DateRange';
import Item from './Item';

type PropsT = {
  value: [any, any],
  label: React$Node,
  attrs: { name: string },
  inputs: { [key: string]: React$Node },
  onChange: (any) => any,
};

export default function DateRangeStructTemplate(locals: PropsT): Node {
  const safeValue = locals.value || [];
  const minValue = safeValue[0] || '';
  const maxValue = safeValue[1] || '';

  const inputNames = Object.keys(locals.inputs);
  const minName = inputNames[0];
  const maxName = inputNames[1];

  return (
    <Item label={locals.label}>
      <DateRange
        name={locals.attrs.name}
        minName={minName}
        maxName={maxName}
        minValue={minValue}
        maxValue={maxValue}
        onChange={locals.onChange}
      />
    </Item>
  );
}
